import { Stack, Typography } from '@mui/material';
import TimerLink from 'components/timer-link/timer-link.component';
import { useTranslation } from 'react-i18next';

const ForgotPasswordSuccess = ({ contact, email, phone, send }) => {
  const { t } = useTranslation();

  return (
    <Stack justifyContent="space-between" flex={1} minHeight="150px">
      <Typography data-testid="ForgotPasswordSuccess.Typography">
        {t('forgotPasswordSuccess.message1', { contact })}
      </Typography>

      <Stack alignItems="center" spacing={1}>
        <Typography textAlign="center">
          {t('forgotPasswordSuccess.message2')}
        </Typography>
        <TimerLink
          expiry={60}
          onClick={() => send('BACK', { data: { email, phone } })}
          label={t('forgotPasswordSuccess.resend')}
        />
      </Stack>
    </Stack>
  );
};
export default ForgotPasswordSuccess;
